import { types } from 'mobx-state-tree';

export const InspectionFileCount = types
  .model({
    inspectionFileCount: types.maybeNull(types.number),
  })
  .views(self => ({
    get getInspectionFileCount() {
      return self.inspectionFileCount;
    },
  }))
  .actions(self => ({
    setInspFileCount: (count: number) => {
      self.inspectionFileCount = count;
    },
    decreaseInspFileCount: () => {
      if (self.inspectionFileCount) {
        self.inspectionFileCount = self.inspectionFileCount - 1;
      }
    },
  }));

export default InspectionFileCount;
